import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const FileSearchIcon = ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width="240"
    height="170"
    viewBox="0 0 327 270"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M297 28.9609H39C34.2261 28.9609 29.6477 30.8574 26.2721 34.233C22.8964 37.6087 21 42.187 21 46.9609V82.9609H297V28.9609Z"
      fill="#E9CECB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M297 18.8398C297 14.0659 295.104 9.48757 291.728 6.11192C288.352 2.73626 283.774 0.839844 279 0.839844H184.926C180.695 0.839546 176.54 1.95763 172.88 4.0808C169.221 6.20398 166.188 9.25677 164.088 12.9298L147 42.8398H297V18.8398Z"
      fill="#E9CECB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21 45.8281H297V57.0061H21V45.8281Z"
      fill="#F5EFEE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M317.208 80.4661C317.679 77.0681 317.416 73.6086 316.437 70.3208C315.458 67.0329 313.786 63.9929 311.534 61.4055C309.281 58.8182 306.501 56.7435 303.379 55.3212C300.257 53.8989 296.867 53.162 293.436 53.1602H24.5643C21.1332 53.16 17.7419 53.8956 14.6192 55.3173C11.4965 56.7389 8.71493 58.8136 6.46202 61.4014C4.20912 63.9893 2.53728 67.0301 1.55922 70.3188C0.581165 73.6075 0.319636 77.0678 0.792269 80.4661L24.1263 248.466C24.9242 254.204 27.7703 259.459 32.1393 263.262C36.5084 267.065 42.1057 269.16 47.8983 269.16H270.102C275.895 269.16 281.492 267.065 285.861 263.262C290.23 259.459 293.076 254.204 293.874 248.466L317.208 80.4661Z"
      fill="#F5EFEE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.80827 94.9861C3.34584 89.0162 6.09628 83.463 10.5193 79.4175C14.9423 75.3719 20.7182 73.1265 26.7123 73.1222H291.288C297.284 73.121 303.063 75.3646 307.487 79.4112C311.911 83.4578 314.66 89.0141 315.192 94.9861L317.208 80.4661C317.679 77.0681 317.416 73.6086 316.437 70.3208C315.458 67.0329 313.786 63.9929 311.534 61.4055C309.281 58.8182 306.501 56.7435 303.379 55.3212C300.257 53.8989 296.867 53.162 293.436 53.1602H24.5643C21.1332 53.16 17.7419 53.8956 14.6192 55.3173C11.4965 56.7389 8.71493 58.8136 6.46202 61.4014C4.20912 63.9893 2.53728 67.0301 1.55922 70.3188C0.581165 73.6075 0.319636 77.0678 0.792269 80.4661L2.80827 94.9861Z"
      fill="#EFE0DE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M132.006 209.318C132.006 206.135 130.742 203.083 128.491 200.832C126.241 198.582 123.188 197.318 120.006 197.318H72.0059C68.8233 197.318 65.771 198.582 63.5206 200.832C61.2701 203.083 60.0059 206.135 60.0059 209.318V221.318C60.0059 224.5 61.2701 227.552 63.5206 229.803C65.771 232.053 68.8233 233.318 72.0059 233.318H120.006C123.188 233.318 126.241 232.053 128.491 229.803C130.742 227.552 132.006 224.5 132.006 221.318V209.318ZM222 96.6016C187.23 96.6016 159 124.832 159 159.602C159 194.372 187.23 222.602 222 222.602C256.77 222.602 285 194.372 285 159.602C285 124.832 256.77 96.6016 222 96.6016ZM222 114.602C246.834 114.602 267 134.768 267 159.602C267 184.436 246.834 204.602 222 204.602C197.166 204.602 177 184.436 177 159.602C177 134.768 197.166 114.602 222 114.602Z"
      fill="#8D2A25"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M254.814 203.109L310.782 259.077C312.469 260.765 314.758 261.714 317.145 261.715C319.533 261.715 321.822 260.767 323.511 259.08C325.199 257.392 326.148 255.103 326.148 252.716C326.149 250.329 325.201 248.039 323.514 246.351L267.546 190.383C265.839 188.788 263.58 187.919 261.245 187.958C258.91 187.998 256.682 188.942 255.03 190.593C253.378 192.244 252.432 194.472 252.392 196.807C252.352 199.142 253.22 201.402 254.814 203.109Z"
      fill="#8D2A25"
    />
  </svg>
);
